export type SignupVariant = 'A' | 'B' | 'C' | 'D';

// Variants that collect a credit card at account creation and gate the app on it.
// Variant D reuses all of Variant B's card-at-creation behaviour, so every variant
// check that drives the card flow routes through this predicate. Variant C shares
// D's direct signup but collects the card at Go Live like control, so it does NOT
// belong here.
export function requiresRegistrationCard(variant?: string | null): boolean {
  return variant === 'B' || variant === 'D';
}

// Variants with no pre-account signup flow ("skip the signup flow"): the marketing
// CTA lands directly on the account-creation page and the user onboards into an
// empty agent (guided setup starts on the Train step, sidebar-less). Every check
// that drives that no-flow/hero layout behaviour routes through this predicate —
// card-related checks use requiresRegistrationCard instead.
export function isDirectSignupVariant(variant?: string | null): boolean {
  return variant === 'C' || variant === 'D';
}

// The redesigned ENG-2201 onboarding (immersive Train → Test → Customize →
// Go Live with the test call right after training) ships to Variant C only;
// every other variant keeps the original flow and step order.
export function isRedesignedOnboardingVariant(variant?: string | null): boolean {
  return variant === 'C';
}
